import React from 'react';

export const specialWalletsConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/specialWallet',
        component: React.lazy(() => import('./SpecialWallets')),
      },
    ],
  },
];
